import { connect } from "react-redux";

import { requestDailyStatistics, filterDataCompressorsMotorstarts } from "../model/util/DailyValues";
import MotorstartsChart from "./MotorstartsChart";

export default connect(state => ({
	model: filterDataCompressorsMotorstarts(state.charts.daily_values.motorstarts, state.ablauf.compressors),
	timespan: state.charts.daily_values.timespan,
	rtc: state.rtc,
	compressors: state.ablauf.compressors
}), dispatch => ({
	refresh: timespan => {
		requestDailyStatistics("motorstarts",
			timespan.from_ms, timespan.until_ms, dispatch);
	}
}))(MotorstartsChart);
